import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { KeyValue } from '../../../../../models/KeyValue';
import { TooltipService } from '../../../../../services/tooltip-service';
import { User } from '../../../../../models/User';
import { ChartData } from '../../../charts/models/ChartData';

@Component({
  selector: 'app-domain-fraudtypes',
  templateUrl: './domain-fraudtypes.component.html',
  styleUrls: ['./domain-fraudtypes.component.scss']
})
export class DomainFraudtypesComponent implements OnInit {
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Output() anchorClick = new EventEmitter<string>();

  tooltipData: KeyValue[];
  barChartData: Array<ChartData> = [];

  get isFreemium(): boolean {
    return this.user.isFreemium();
  }

  constructor(private tooltipService: TooltipService, private user: User) {}

  ngOnInit() {
    this.tooltipData = this.tooltipService.getMap();
    const chartData = [];
    if (this?.data?.ivtDistribution?.givtFraudTypes?.length > 0) {
      chartData.push(...this?.data?.ivtDistribution?.givtFraudTypes);
    }

    if (this?.data?.ivtDistribution?.sivtFraudTypes?.length > 0) {
      chartData.push(
        ...this?.data?.ivtDistribution?.sivtFraudTypes.map(item => {
          item.givtRate = item.sivtRate;
          return item;
        })
      );
    }

    chartData.sort(function (a, b) {
      return b.givtRate - a.givtRate;
    });

    this.barChartData = chartData;
  }

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }
}
